import { Box, Text, Link } from '@solvhealth/jigsaw-v1';
import React from 'react';
import LocationInterface from '@solvhealth/types/interfaces/Location';

type Props = {
  location: LocationInterface;
  handleRouteToCdpClick?: (...args: any[]) => void;
};

const NoPreviewView = ({ location, handleRouteToCdpClick }: Props) => {
  return (
    <Box alignItems="center" display="flex" flexDirection="column" pt={1}>
      <Box display="flex">
        <Text variant="body2">No available appointments today.</Text>
      </Box>
      <Link
        fontSize="sm"
        href={`${location.urlSlug}?target=booking`}
        onClick={handleRouteToCdpClick}
        sx={{ textDecoration: 'underline' }}
      >
        View next available visit
      </Link>
    </Box>
  );
};

export default NoPreviewView;
